import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import moment from 'moment';
import { AppService } from 'src/app/app.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-training-dashboard-detail',
  templateUrl: './training-dashboard-detail.component.html',
  styleUrls: ['./training-dashboard-detail.component.scss']
})
export class TrainingDashboardDetailComponent implements OnInit {


  trainingData: any = {}
  isProcessing = false;
  contentList: any = [];
  title = "";
  reasonForRelaunch = "";
  @ViewChild('reasonPopup', { static: true }) reasonPopup: TemplateRef<any>;
  @ViewChild('selfAssignPopup', { static: true }) selfAssignPopup: TemplateRef<any>;
  visibleReasonPopup: MatDialogRef<TemplateRef<any>>;
  visibleSelfAssignPopup: MatDialogRef<TemplateRef<any>>;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public sanitizer: DomSanitizer) {

  }

  isSelfAssign = false;
  isEsignRequired: boolean = false;
  reasonForSign: any;
  userName: any;
  password: any = '';
  userDetails: any = {};
  orgData: any = {};
  timezone: any;
  displayUserName: any;
  ngOnInit(): void {
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.timezone = localStorage.getItem("timezone");
    if (this.timezone == "null") {
      this.timezone = "GMT"
    }
    this.trainingData = this.appService.getTrainingData();
    
    if (this.trainingData['searchedTraining']) {
      this.isProcessing = true;
      this.appService.getUserTrainingByTrainingIdAndVersion(this.trainingData['trainingId'], this.trainingData['version']).subscribe((data: any) => {
        if (data.length > 0) {
          data[0].status = this.trainingData.status;
          this.trainingData = data[0];
        }
        if (this.trainingData['selfAssignable'] == 'Y') {
          this.isSelfAssign = true;
        }
        this.isProcessing = false;
      })
    } else {
      this.isProcessing = true;
      this.appService.getUserTrainingsByTrainingId(this.trainingData['userTrainingId']).subscribe((data: any) => {
        this.trainingData = data[0];
        this.isProcessing = false;
      })
    }
    this.appService.getTmsSettingsVwDetails().subscribe((response: any) => {
      if (response != null) {
        if (response.esignatureAtTrainingCompletion == "Y") {
          this.isEsignRequired = true;
        } else {
          this.isEsignRequired = false;
        }

        let data = {
          stageName: 'Completion',
          status: 'Complete',
          module: "TRN",
        }
        this.appService.getReasonForSigns(data).subscribe((data: any) => {
          if (data.length > 0) {
            this.reasonForSign = data[0].reasonForSignature;
          }
        })

        this.appService.getUserDetailsForTrainingDashboard().subscribe((data: any) => {
          this.userDetails = data[0];
        })
      }
    })
    
    this.appService.getAllOrgReportImages().subscribe((response1: any) => {
      this.oneQmsOrgImagesDetails = response1;
    })

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })

    this.isProcessing = true;
    this.appService.getContentsList(this.trainingData['trainingId'], this.trainingData['version'])
      .subscribe((data: any) => {
        this.contentList = data;
        this.isProcessing = false;
      })
  }
  reasonPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  selfAssignPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };


  redirectToBack() {
    this.router.navigate(['/dashboard/trainingDashboard']);
  }

  startTraining(value: any) {

    this.isProcessing = true;
    let data = {
      userTrainingId: this.trainingData['userTrainingId'],
      action: 'LAUNCH',
      relaunchReason: null,
    };
    this.appService.launchTraining(data).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S') {
          this.isProcessing = false;
          this.appService.setTrainingDetails(null, this.trainingData)
          this.router.navigate(['/launchTraining']);
        } else {
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }


      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  startTrainingWithReason(value: any) {
    this.isProcessing = true;
    let data = {
      userTrainingId: this.trainingData['userTrainingId'],
      action: 'RELAUNCH',
      relaunchReason: this.reasonForRelaunch,
    };
    this.appService.launchTraining(data).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S') {
          this.isProcessing = false;
          this.visibleReasonPopup.close();
          this.appService.setTrainingDetails(null, this.trainingData)
          this.router.navigate(['/launchTraining']);
        } else {
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }


      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }



  cancelReasonFunction() {
    this.visibleReasonPopup.close();
  }

  closeCertificationpopup() {
    this.visibleCertificationPopup.close();
  }

  reasonFiledValueRequiredMsg: any;
  reasonFiledValue: any;
  deleteValidation() {
    this.reasonFiledValueRequiredMsg = document.getElementById('reasonTextarea-required-msg') as HTMLInputElement;
    if (this.reasonForRelaunch == '') {
      this.isProcessing = false;
      this.reasonFiledValue.style.border = '1px solid red';
      this.reasonFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.reasonFiledValue.style.border = 'none';
      this.reasonFiledValueRequiredMsg.style.display = 'none';
    }
  }

  reasonRelaunchFun() {
    this.reasonForRelaunch = "";
    this.title = "Relaunch Reason";
    this.visibleReasonPopup = this.dialog.open(this.reasonPopup, this.reasonPopupConfig);
  }

  reasonRelaunchFunction() {
    this.isProcessing = true;
    this.reasonFiledValue = document.getElementById('reasonTextarea') as HTMLInputElement;
    if (this.reasonFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      this.startTrainingWithReason('RELAUNCH');
      this.isProcessing = false;
    }
  }

  selfAssignFunc() {
    this.visibleSelfAssignPopup = this.dialog.open(this.selfAssignPopup, this.selfAssignPopupConfig);
  }

  selfAssignOkFunc() {
    this.isProcessing = true;
    let data = {
      trainingId: this.trainingData['trainingId'],
      version: this.trainingData['version']
    }
    this.appService.selfAssignTraining(data).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S') {
          this.isProcessing = false;
          this.visibleSelfAssignPopup.close();
          this.isSelfAssign = false;
          this.isProcessing = true;
          this.appService.getUserTrainingByTrainingIdAndVersion(this.trainingData['trainingId'],
            this.trainingData['version']).subscribe((data: any) => {
              const activeTraining = data.find((t:any) => t.levelStatus === 'Pending' || t.levelStatus === 'In Progress') 
                                 || data.reduce((prev:any, current:any) => (prev.userTrainingId > current.userTrainingId) ? prev : current);
              this.trainingData = activeTraining;
              this.isProcessing = false;
            })
        } else {
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }


      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  cancelSelfAssignFunc() {
    this.visibleSelfAssignPopup.close();
  }


  visibleCertificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('certificationPopup', { static: true }) certificationPopup: TemplateRef<any>;

  certificationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '100px' },
  };

  oneQmsOrgImagesDetails: any = {};
  isDefaultTemplate: boolean = false;
  isWithScoreTemplate: boolean = false;
  certificateTemplate: any = {};
  certificateData: any;
  certificate() {
    this.isDefaultTemplate = false;
    this.isWithScoreTemplate = false;
    if (this.trainingData.finalScore) {
      this.isProcessing = true;
      this.appService.getTrainingCertificateTemplates().subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          for (const template of data) {
            if (template.isDefaultWithscoreTemplate === "Y") {
              this.certificateTemplate = template;
              break;
            }
          }
          if (this.certificateTemplate.template == undefined || this.certificateTemplate.template == null) {
            this.isDefaultTemplate = false;
          } else {
            this.isDefaultTemplate = true;
            this.buildCertificateData(this.certificateTemplate.template);
          }
          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
        }, error: (error) => {
          this.isProcessing = false;
          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
          throw error;
        }
      });
      this.isWithScoreTemplate = true;
    } else {
      this.isProcessing = true;
      this.appService.getTrainingCertificateTemplates().subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          for (const item of data) {
            if (item.isDefaultWithoutscoreTemplate === "Y") {
              this.certificateTemplate = item;
              break;
            }
          }
          if (this.certificateTemplate.template == undefined || this.certificateTemplate.template == null) {
            this.isDefaultTemplate = false;
          } else {
            this.isDefaultTemplate = true;
            this.buildCertificateData(this.certificateTemplate.template);
          }
          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
        }, error: (error) => {
          this.isProcessing = false;
          this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
          throw error;
        }
      });
      this.isWithScoreTemplate = false;
    }
  }

  buildCertificateData(data: any) {
    if (data.includes("&lt;PERCENTAGE&gt;")) {
      data = data.split("&lt;PERCENTAGE&gt;").join(this.trainingData.finalScore);
    }
    if (data.includes("&lt;ORG_NAME&gt;")) {
      data = data.split("&lt;ORG_NAME&gt;").join(this.orgData.orgLongName ?? "");
    }
    if (data.includes("&lt;ORG_LOGO&gt;")) {
      if (this.oneQmsOrgImagesDetails != undefined && this.oneQmsOrgImagesDetails != null) {
        data = data.split("&lt;ORG_LOGO&gt;").join(this.oneQmsOrgImagesDetails.logoImage);
      } else {
        data = data.split("&lt;ORG_LOGO&gt;").join("");
      }

    }
    if (data.includes("&lt;TRAINING_NAME&gt;")) {
      data = data.split("&lt;TRAINING_NAME&gt;").join(this.trainingData.trainingName);
    }
    if (data.includes("&lt;TRAINING_TYPE&gt;")) {
      data = data.split("&lt;TRAINING_TYPE&gt;").join(this.trainingData.type);
    }
    if (data.includes("&lt;COMPLETED_ON&gt;")) {
      let date = this.convertTZ(new Date(this.trainingData.completedOn), localStorage.getItem("timezone") ? localStorage.getItem("timezone") : "GMT")
      data = data.split("&lt;COMPLETED_ON&gt;").join(date);
    }
    if (data.includes("&lt;USER_FIRST_NAME&gt;")) {
      data = data.split("&lt;USER_FIRST_NAME&gt;").join(this.userDetails.firstName);
    }
    if (data.includes("&lt;USER_LAST_NAME&gt;")) {
      data = data.split("&lt;USER_LAST_NAME&gt;").join(this.userDetails.lastName);
    }
    if (data.includes("&lt;REASON_FOR_SIGN&gt;")) {
      data = data.split("&lt;REASON_FOR_SIGN&gt;").join(this.trainingData.reasonForSignature ?? "");
    }
    if (data.includes("&lt;USER_DESIGNATION&gt;")) {
      data = data.split("&lt;USER_DESIGNATION&gt;").join(this.userDetails.designation ?? "");
    }
    this.certificateData = this.sanitizer
      .bypassSecurityTrustHtml(data);
  }

  convertDate(date: any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    const year = date.getFullYear();

    return `${day}-${monthName}-${year}`
  }


  public downloadAsPdf(): void {
    let data: any;
    if (this.isDefaultTemplate) {
      data = document.getElementById('dataToExportFromTemp');  //Id of the table
    } else {
      data = document.getElementById('dataToExport');  //Id of the table
    }

    html2canvas(data).then(canvas => {
      // Few necessary setting options
      let imgWidth = 208;
      let imgHeight = canvas.height * imgWidth / canvas.width;

      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf = this.addWaterMark(pdf);
      pdf.save('Certificate.pdf'); // Generated PDF
    });
  }
  addWaterMark(doc: any) {
    let timezone;
    if (localStorage.getItem("timezone") && localStorage.getItem("timezone") != null && localStorage.getItem("timezone") != "null") {
      console.log("timezone==", localStorage.getItem("timezone"));
      timezone = localStorage.getItem("timezone");
    } else {
      console.log("timezone=", "GMT");
      timezone = "GMT";
    }
    let totalPages = doc.internal.getNumberOfPages();
    let watermark = "Printed by: " + localStorage.getItem("loggedUserName") + " | Printed on: " + this.convertTZ(new Date(), timezone) + "(" + timezone + ")";
    const fontSize = 12;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setTextColor(150);
      doc.setFontSize(fontSize);
      doc.text(5, doc.internal.pageSize.height - 5, watermark);
    }
    return doc;
  }

  convertDateAndTime(date: Date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate();

    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];

    const year = date.getFullYear();
    return `${day}-${monthName}-${year} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  }
  convertTZ(date: any, timezone: any) {
    if (!timezone || timezone === 'null') {
      timezone = "GMT";
    }
    console.log("timezone===", timezone);
    let dt = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: timezone }));
    let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let date2 = dt.getFullYear() + "-" + month_names[dt.getMonth()] + "-" + dt.getDate();
    let date1 = moment(date2).format(this.appService.organizationDetails?.htmlDateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.htmlDateFormat.toUpperCase());
    let hours = dt.getHours();
    let minutes: any = dt.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours || 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;

    return date1 + " " + strTime;


  }

}


